<div class="sq-page">
	<div class="sq-card">
		<!-- Header -->
		<div class="sq-header">
			<img class="sq-logo" src="/assets/Logo.png" onerror="this.style.display='none'" alt="BPL Engineering Group" />
			<div class="sq-title">
				<h1>Request for Quote</h1>
				<div class="sq-sub">BPL Engineering Group Ltd</div>
			</div>
		</div>

		<!-- Loading -->
		<div *ngIf="loading" class="sq-message">Loading your RFQ&hellip;</div>

		<!-- Invalid / expired link -->
		<div *ngIf="!loading && errorMessage" class="sq-message sq-error">
			<h2>We couldn't open this RFQ</h2>
			<p>{{ errorMessage }}</p>
		</div>

		<div *ngIf="submitted" class="sq-thanks">
			<div class="sq-thanks-tick">&#10003;</div>
			<h2>RFQ submitted</h2>
			<p class="sq-thanks-lead">
				Thank you, your RFQ Response has been sent to BPL Engineering Group.
			</p>

			<p class="sq-thanks-next">
				Our purchasing team will review your response. If we need anything further we will contact you
				using the details you provided &mdash; there is nothing more for you to do. This link is now
				closed, so please keep a copy of this page for your records.
			</p>
			<p class="sq-thanks-foot">
				BPL Engineering Group Ltd &bull; 5 Catesby Park, Kings Norton, Birmingham, B38 8SE &bull; 0121 735 2224
			</p>
		</div>

		<!-- Form -->
		<div *ngIf="!loading && !errorMessage && !submitted">
			<p class="sq-intro">Please enter the line totals for the items below:</p>
			<dx-data-grid id="grid" class="data-grid" id="gridContainer" [dataSource]="lineItems" [remoteOperations]="false" [allowColumnReordering]="false" [rowAlternationEnabled]="true" [showBorders]="true">
				<dxo-pager [visible]="false"></dxo-pager>
				<dxo-search-panel [visible]="false" [highlightCaseSensitive]="true"></dxo-search-panel>
				<dxo-sorting mode="none"></dxo-sorting>
				<dxo-group-panel [visible]="false"></dxo-group-panel>
				<dxo-grouping [autoExpandAll]="false"></dxo-grouping>
				<dxo-export [enabled]="false"></dxo-export>
				<dxo-editing [allowUpdating]="true" mode="cell" [allowDeleting]="false" [confirmDelete]="false"></dxo-editing>
				<dxi-column [allowEditing]="false" dataField="lineDescription" dataType="string" alignment="left"></dxi-column>
				<dxi-column caption="Line Price (£)" [showEditorAlways]="true" dataField="linePrice" dataType="number" alignment="left" [format]="{ style: 'currency', currency: 'GBP', useGrouping: true, precision: 4 }"></dxi-column>
			</dx-data-grid>
			<div class="sq-actions">
				<dx-button text="Submit Questionnaire" type="default" [disabled]="saving" (onClick)="submit()"></dx-button>
			</div>
		</div>
	</div>
</div>
